import { differenceInCalendarDays } from 'date-fns';

// Compact relative date — "today"/"yesterday"/"Nd ago" — used anywhere a full
// date+time would crowd out more important content (a chore title, a name).
export const relativeDay = (dateStr) => {
  const days = differenceInCalendarDays(new Date(), new Date(dateStr));
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days}d ago`;
};
